import { isTaskOverdue } from './taskPresentation';

type Action = {parent_task_id?: string | null; status: string; due_by?: string | null; priority?: string | null};
/** Count top-level actions of every type, once per workflow. */
export function actionCounts(tasks: Action[]) {
  const top = tasks.filter(t => !t.parent_task_id);
  const open = top.filter(t => !['complete', 'cancelled'].includes(t.status));
  return {
    open: open.length,
    overdue: open.filter(isTaskOverdue).length,
    urgent: open.filter(t => t.priority === 'critical').length,
    complete: top.filter(t => t.status === 'complete').length,
  };
}
